<div class="flex flex-col gap-4" [dir]="isArabic() ? 'rtl' : 'ltr'">
  <div class="flex items-center justify-between">
    <h1 class="text-primary text-2xl font-bold" i18n="@@userManagementTitle">User Management</h1>
    <a
      *hasScope="SCOPES.USERS.CREATE"
      routerLink="/admin/user-management/add-user"
      class="bg-primary hover-bg-primary-hover flex items-center gap-1 rounded-lg px-4 py-2 text-sm text-white">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
      </svg>
      <span i18n="@@adminUsersAddUserButton">Add User</span>
    </a>
  </div>

  <div class="rounded-2xl bg-white p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
    <app-filter
      [filters]="filters()"
      [rolesList]="rolesList()"
      (applyFilters)="onApplyFilters($event)"
      (resetFilters)="onResetFilters()"
      (toggleSortOrder)="onToggleSortOrder()" />

    <app-user-table-component
      [users]="usersList()"
      [state]="state()"
      [isFiltersApplied]="isFiltersApplied()"
      (retry)="loadUsers()"
      (actionClick)="handleAction($event)" />
  </div>

  @if (state() === "success") {
    <app-pagination
      [itemsPerPage]="itemsPerPage()"
      [currentPage]="currentPage()"
      [getPageNumbers]="pageNumbers()"
      [totalPages]="totalPages()"
      [startItem]="startItem()"
      [endItem]="endItem()"
      [totalItems]="totalItems()"
      (previousPage)="goToPage(currentPage() - 1)"
      (nextPage)="goToPage(currentPage() + 1)"
      (goToPage)="goToPage($event)"
      (changePageNumber)="onPageSizeChange(+$event)" />
  }
</div>
